import { findSameGiftItem } from "../../../api/helpers/shoppingCartHelper";
const state = {
  cartItems: [],
  deliveryFee: 0,
  isDelivery: false
};

export const mutations = {
  giftIsDelivery(state, isDelivery) {
    state.isDelivery = isDelivery;
  },
  Add_GiftcartItem(state, { item, quantity, message }) {
    let now = new Date();
    const records = state.cartItems.filter(element => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameGiftItem(item, message, records);
      if (!find) {
        same = false;
      }
    } else {
      same = false;
    }
    if (!same) {
      state.cartItems.push({
        ...item,
        quantity,
        message,
        created: now.toUTCString()
      });
    } else {
      find.quantity += quantity;
      find.created = new Date().toUTCString();
    }
  },
  Set_GiftItems(state, items) {
    if (items) {
      state.cartItems = items;
    }
  },
  REMOVE_GIFTCART_ITEM(state, { item }) {
    const record = state.cartItems.find(element => element.id == item.id);
    state.cartItems.splice(state.cartItems.indexOf(record), 1);
  },
  UpdateGiftItemQuantity(state, { item, quantity, message }) {
    const records = state.cartItems.filter(element => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameGiftItem(item, message, records);
      if (!find) {
        same = false;
      }
      if (same) {
        find.quantity = quantity;
        if (quantity == 0) {
          state.cartItems.splice(state.cartItems.indexOf(find), 1);
        }
      }
    }
  }
};

export const actions = {
  clearGiftCart: ({ commit }) => {
    commit("Set_GiftItems", []);
  }
};

export const getters = {
  giftIsDelivery: state => {
    return state.isDelivery;
  },
  giftCartItems: state => {
    let copy = [...state.cartItems];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  giftCartTotalQuantity: state => {
    let copy = [...state.cartItems];
    let totalQuantity = 0;
    copy.forEach(element => {
      totalQuantity += Number(element.quantity);
    });
    return totalQuantity;
  },
  giftCartValue: state => {
    let res = 0;
    state.cartItems.map(item => {
      res += item.price * item.quantity;
    });
    return res;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
